import { Prop, Component, Vue } from 'vue-property-decorator';
import MiDataTable, { MiDataTableOptions, MiDataTableVisibility } from '@/components/MiDataTable/MiDataTable';
import { ExcelExportLogs, ExcelExportLogsFilters, ExcelExportLogsIncludes } from '@/models/ExcelExportLogs';

@Component<StorageDataTable>({
  components: {
    //
  },
})
export default class StorageDataTable extends Vue {
  // File structure for Typescript files in your Vue project
  // https://tutorials.atabix.com/frontend/typscript_file_structure/

  // #region @Props
  @Prop({ default: () => ({
    filters: false,
    search: true,
  }) })
  protected tableVisibility!: MiDataTableVisibility;
  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Class methods
  protected refreshDatatable(): void {
    this.datatable.refresh();
  }

  protected logLabel(log: ExcelExportLogs): string {
    return new ExcelExportLogs(log).typeLabel;
  }

  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters
  protected get tableOptions(): MiDataTableOptions {
    return {
      model: new ExcelExportLogs()
        .include([ExcelExportLogsIncludes.USER])
        .filter({
          [ExcelExportLogsFilters.TYPE]: 'general_hin_report_statistics',
        }),
      limit: 15,
      headers: [
        {
          text: 'Tijd',
          value: 'created_at',
        },
        {
          text: 'Gebruikersnaam',
          value: 'user.name',
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
      ],
    };
  }

  protected get datatable(): MiDataTable {
    return this.$refs.contractorDatatable as MiDataTable;
  }

  // #endregion

  // #region @Watchers
  // #endregion
}
